export default __webpack_public_path__ + "static/media/starling.9da75dc4.jpg";